import React, { useState, useEffect } from "react";
import axios from "axios";
import baseUrl from "../../api/universalApi";
import "./Admin.css";
import RunningCampaign from "./RunningCampaign";
//import UpdateInfluxPoint from "./UpdateInfluxPoint";
import CreatorList from "./CreatorList";
import PaymentTimeline from "./PaymentTimeline";
import UpdateCampaign from "./UpdateCampaign";
import Home from "./Home";
import CryptoJS from "crypto-js";

import {
  House,
  TvMinimalPlay,
  User,
  ClockArrowDown,
  ChevronLeft,
  ChevronRight,
  FilePlus2,
  ShieldUser
} from "lucide-react";
import { motion } from "framer-motion";

const NAV_ITEMS = [
  { id: "home", label: "Home", icon: <House size={20} /> },
  { id: "timeline", label: "Timeline", icon: <ClockArrowDown size={20} /> },
  { id: "running", label: "Running", icon: <TvMinimalPlay size={20} /> },
  { id: "creators", label: "Creators", icon: <User size={20} /> },
  { id: "update", label: "Update", icon: <FilePlus2 size={20} /> },
];

const Admin = ({ creators, handleCamapaignId }) => {
  //const [creatorData, setCreatorData] = useState(null);
  const [accessPopup, setAccessPopup] = useState(true);
  const [brands, setBrands] = useState([]);

  const [activeNav, setActiveNav] = useState("home");
  const [navOpen, setNavOpen] = useState(true);
  const [campaigns, setCampaigns] = useState([]);

  const ENCRYPTION_KEY = "your-32-char-secret-key"; // Must match the backend

  const decryptData = (encryptedText) => {
    const bytes = CryptoJS.AES.decrypt(encryptedText, ENCRYPTION_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  };

  const fetchAllCampaigns = async () => {
    try {
      const response = await fetch(`${baseUrl}/api/campaign/fetchAllCampaigns`);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
    //  console.log("cam", data)
      localStorage.setItem("campaigns", JSON.stringify(data));
      setCampaigns(data);
    } catch (error) {
      console.error("Error fetching payment timeline:", error);
    }
  };

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const response = await fetch(`${baseUrl}/auth2/getAllBrands`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();

        const decryptedData = decryptData(data?.user);

        //console.log("Fetched Brands:", decryptedData);
        setBrands(decryptedData);
      } catch (error) {
        console.error("Error fetching brands:", error);
      }
    };

    fetchAllCampaigns();
    fetchBrands();
  }, []);

  const renderComponent = () => {
    switch (activeNav) {
      case "home":
        return <Home campaigns={campaigns} creators={creators} />;
      case "timeline":
        return (
          <PaymentTimeline
            campaigns={campaigns}
            fetchAllCampaigns={fetchAllCampaigns}
          />
        );
      case "running":
        return (
          <RunningCampaign
            creators={creators}
            handleCamapaignId={handleCamapaignId}
          />
        );
      case "creators":
        return <CreatorList creators={creators} />;
      case "update":
        return <UpdateCampaign />;
      default:
        return null;
    }
  };

  const [accessCode, setAccessCode] = useState("");
  const predefinedCode = "2123";

  useEffect(() => {
    const savedAccessCode = localStorage.getItem("accessCode");
    if (savedAccessCode === predefinedCode) {
      setAccessPopup(false);
    }
  }, []);

  const handleAccessCodeChange = (e) => {
    setAccessCode(e.target.value);
  };

  const handleAccessCodeSubmit = () => {
    if (accessCode === predefinedCode) {
      localStorage.setItem("accessCode", accessCode);
      setAccessPopup(false);
    } else {
      alert("Incorrect code. Please try again.");
    }
  };

  return (
    <>
      <div
        className="flex min-h-screen font-sans bg-gray-100"
        style={{ fontFamily: "Gilroy-Medium" }}
      >
        {/* Sidebar */}
        <motion.div
          animate={{ width: navOpen ? 240 : 64 }}
          className="bg-white border-r border-gray-200 p-4 flex flex-col justify-between"
        >
          <div>
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center"> <ShieldUser /></div>
              {navOpen && <span className="font-bold text-lg">Admin</span>}
            </div>

            <nav className="space-y-2">
              {NAV_ITEMS.map((item) => (
                <button
                  key={item.id}
                  className={`flex items-center w-full px-3 py-2 rounded-full hover:bg-gray-200 transition ${
                    activeNav === item.id ? "bg-pink-200  text-pink-500 font-bold" : "text-black"
                  }`}
                  onClick={() => setActiveNav(item.id)}
                >
                  <span className=" text-bold"> {item.icon}</span>

                  {navOpen && (
                    <span className="ml-2 text-bold">
                      {item.label}
                    </span>
                  )}
                </button>
              ))}
            </nav>
          </div>

          <button
            onClick={() => setNavOpen(!navOpen)}
            className="flex items-center justify-center w-full mt-4 text-gray-600 hover:text-black"
          >
            {navOpen ? <ChevronLeft /> : <ChevronRight />}
          </button>
        </motion.div>

        {/* Main Content */}
        <div className="flex-1 p-4 overflow-auto">{renderComponent()}</div>
      </div>

      <div className="" style={{ fontFamily: "Gilroy-Medium" }}>
        {accessPopup && (
          <>
            {/* Blurred Background Overlay */}
            <div className="fixed inset-0 bg-gray-400 bg-opacity-40 backdrop-blur-md z-40"></div>

            {/* Modal */}
            <div className="fixed inset-0 flex items-center justify-center z-50">
              <div className="bg-white shadow-lg rounded-lg p-6 w-96">
                <div className="text-lg font-semibold mb-4">
                  Enter Access Code
                </div>
                <p className="text-gray-600 mb-4">
                  Please enter the 4-digit access code to proceed.
                </p>
                <input
                  type="text"
                  className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={accessCode}
                  onChange={handleAccessCodeChange}
                  maxLength="4"
                />
                <div className="mt-4 flex justify-end">
                  <button
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md"
                    onClick={handleAccessCodeSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Admin;
